'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var RefreshIcon_module = require('./RefreshIcon.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function RefreshIcon({
  isLoading
}) {
  return /*#__PURE__*/React__default["default"].createElement("svg", {
    className: isLoading ? RefreshIcon_module["default"].refreshIconSpin : '',
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_515_1252)"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "14",
    height: "14",
    fill: "none"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M0.583252 2.3335V5.8335H4.08325",
    stroke: "#999999",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.4167 11.6665V8.1665H9.91675",
    stroke: "#999999",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.9524 5.25008C11.6566 4.41404 11.1538 3.66657 10.4909 3.07741C9.82803 2.48825 9.02673 2.07661 8.16175 1.8809C7.29677 1.68519 6.39631 1.71178 5.54439 1.9582C4.69247 2.20462 3.91685 2.66283 3.28992 3.29008L0.583252 5.83342M13.4166 8.16675L10.7099 10.7101C10.083 11.3373 9.30737 11.7955 8.45545 12.042C7.60353 12.2884 6.70306 12.315 5.83809 12.1193C4.97311 11.9236 4.1718 11.5119 3.50894 10.9228C2.84608 10.3336 2.34327 9.58613 2.04742 8.75009",
    stroke: "#999999",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_515_1252"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "14",
    height: "14",
    fill: "none"
  }))));
}

exports.RefreshIcon = RefreshIcon;
